import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function langRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@lang-url-segment:en`;
  }
  return (appRoutesI18nCache['en'] ??= $localize`:url-segment@@lang-url-segment:en`);
}
